import {Injectable} from "@angular/core";
import {LicenseProxy} from "./license.proxy";
import {HttpObservable} from "../../common/http-helpers/http.wrapper";
import {Observable, ReplaySubject} from "rxjs";
import {Router} from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class LicenseService {

  constructor(private licenseProxy: LicenseProxy) { }

  public validateLicense(isPatientPortal: boolean, isPatientKiosk: boolean): HttpObservable<boolean> {
    return this.licenseProxy.validateLicense(isPatientPortal, isPatientKiosk);
  }

}
